import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { leaders as leadersLayout } from 'constants/layout'
import { apiCodeLists, apiCommon, apiLeaders } from 'helpers/decorators/api'
import { renderRoutes } from 'react-router-config'
import { routerAdapter } from 'helpers/decorators'

@routerAdapter()
@apiCodeLists([
  'genders',
  'phoneTypes',
  'titles',
  'organizationContactReasonsOfDeletionTypes',
  'personStates'
])
@apiCommon({
  regions: true
})
@apiLeaders({
  detail: true,
  updateDetail: true,
  detailReadParams: 'AWARD_LEADERSHIP_HISTORY,TRAININGS'
})
class Leader extends Component {
  static propTypes = {
    children: PropTypes.any,
    tabs: PropTypes.object.isRequired,
    route: PropTypes.object
  }

  render() {
    const { tabs, children, route } = this.props

    return (
      <div>
        {React.cloneElement(tabs, {
          links: leadersLayout.tabs
        })}
        {children && React.cloneElement(children, {
          ...this.props
        })}
        {renderRoutes(route.routes, this.props)}
      </div>
    )
  }
}

export default Leader
